import * as React from 'react'
import Table from '@components/table/table'
import { YesNoBadge } from '@components/badges/yes-no'
import { useApiRequest } from '@components/hooks/use-api-request'
import { commonObjectPatch } from '@store/actions/generic-actions'
import { useAppDispatch } from '@store/index'
import { useNotificationHook } from '@hyper/use-notification-hook'
import Spinner from '@hyper/spinner'
import { HousekeepingUser } from '@modules/housekeeping/models'
import { updateHousekeepingUserDetails } from '@store/slices/housekeeping-slice'

interface Props {
  user: HousekeepingUser
}

export const HousekeepingUsersListTableRowActive: React.FC<Props> = ({ user }) => {
  const { addSuccessNotification } = useNotificationHook()
  const dispatch = useAppDispatch()
  const { isLoading, action: handleClick } = useApiRequest(async () => {
    dispatch(
      updateHousekeepingUserDetails(
        await commonObjectPatch<HousekeepingUser>(user.urls.details, { is_active: !user.is_active }),
      ),
    )
    addSuccessNotification('Zmiany zostały zapisane')
  })

  return (
    <Table.Cell>
      {isLoading ? (
        <Spinner size="xxs" className="text-muted" />
      ) : (
        <YesNoBadge value={user.is_active} onClick={handleClick} className="cursor-pointer" />
      )}
    </Table.Cell>
  )
}
